import * as angular from "angular";
import {IController} from "angular";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class analysisLogsTableCtrl implements IController {

  loading: any;
  isDone: any;
  doReload: boolean;
  onAbortLog: Function;
  onReload: Function;

  private loadLimit: any;
  private logsRef: any;
  private filterConfig: any;
  private infiniteScroll: any;

  /* @ngInject */
  constructor(private $serviceAnalysis, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $infiniteScroll, private $log) {}

  $onInit() {
    this.loadLimit = 30;
    this.logsRef = this.$serviceAnalysis();

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTimeFiltersService.thisMonth(),
      queryString: undefined,
      isDone: this.isDone
    };

    this.logsRef.$query(this._getLogsQuery());
    this.infiniteScroll = this.$infiniteScroll(this.logsRef, this.loadLimit)

  };

  $onChanges(changes) {
    if (changes.isDone && !changes.isDone.isFirstChange()) {
      this.filterConfig.isDone = this.isDone;
      this._loadLogs();
    }

    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (!!this.doReload) {
        this._loadLogs();
        this.onReload();
      }
    }
  };


  private _loadLogs() {
    this.logsRef.$query(this._getLogsQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getLogsQuery() {
    return {
      isDone: this.filterConfig.isDone,
      limit:  this.loadLimit
    }
  }

}

angular
  .module('bringoz.admin.service-analysis')
  .component('analysisLogsTable', {
    bindings: {
      loading: '<',
      isDone: '<',
      doReload: '<?',
      onAbortLog: '&',
      onReload: '&'
    },
    template: require('./analysis-logs-table.html').default,
    controller: analysisLogsTableCtrl
  });
